import { useState } from "react";
import { Box } from "@mui/material";
import { PATHS } from "constants/pathConstants";
import { useHistory, useLocation } from "react-router-dom";
import {
  getStandaloneSurveyRootSx,
  getStandaloneSurveySlotSx,
  STANDALONE_SURVEY_SURFACE_CLASS
} from "components/v3/layouts/StandaloneSurveyPageLayout";
import SurveyWrapper from "components/v3/sharedComponents/surveys/SurveyWrapper";
import SurveySummary from "components/v3/sharedComponents/surveys/SurveySummary";
import {
  trackSurveyAbandonAttempted,
  trackSurveyCompleted
} from "analytics";
import { Model } from "survey-core";

const SURVEY_ID = "kit-request-questions";
const WORKFLOW = "kit_request_survey" as const;

const KitRequestSurvey = (): React.ReactElement => {
  const history = useHistory();
  const location = useLocation();
  const [showSummary, setShowSummary] = useState<boolean>(false);
  const [summarySurveyModel, setSummarySurveyModel] = useState<Model | null>(
    null
  );

  const handleOnConfirm = (): void => {
    if (!summarySurveyModel) return;

    trackSurveyCompleted({
      surveyId: SURVEY_ID,
      workflow: WORKFLOW,
      outcome: "completed"
    });

    setShowSummary(false);
    summarySurveyModel.doComplete();
  };

  const handleOnCompleting = (
    surveyModel: Model,
    options: { allow: boolean }
  ): void => {
    if (!showSummary) {
      options.allow = false;
      setSummarySurveyModel(surveyModel);
      setShowSummary(true);
    }
  };

  const handleOnComplete = (): void => {
    history.push({
      pathname: PATHS.ORDER_KIT_SELECTION,
      search: location.search
    });
  };

  const handleOnSurveyInstantiated = (surveyModel: Model): void => {
    surveyModel.pagePrevText = "Back";
  };

  return (
    <Box sx={getStandaloneSurveyRootSx(showSummary)}>
      {showSummary && summarySurveyModel && (
        <Box
          className={STANDALONE_SURVEY_SURFACE_CLASS}
          sx={{
            borderRadius: "16px",
            padding: {
              xs: "16px",
              md: "32px 64px 0 64px"
            }
          }}
        >
          <SurveySummary
            onBack={() => {
              trackSurveyAbandonAttempted({
                surveyId: SURVEY_ID,
                workflow: WORKFLOW,
                action: "cancelled_exit"
              });
              setShowSummary(false);
            }}
            onSubmit={handleOnConfirm}
            surveyModel={summarySurveyModel}
          />
        </Box>
      )}
      <Box sx={getStandaloneSurveySlotSx(showSummary)}>
        <SurveyWrapper
          containerClassName="kit-request-questions-container"
          fillViewport
          onSurveyInstantiated={handleOnSurveyInstantiated}
          onComplete={handleOnComplete}
          onCompleting={handleOnCompleting}
          overrideNextButtonEnabled={true}
          surveyId={SURVEY_ID}
          trackCompletion={false}
        />
      </Box>
    </Box>
  );
};

export default KitRequestSurvey;
